export const GLOBAL_PLAYER_TIME_SLIDER_CONTAINER_ID =
  "global-player-time-slider-container";
export const GLOBAL_PLAYER_TIME_SLIDER_ELEMENT_ID =
  "global-player-time-slider";
export const GLOBAL_PLAYER_TIME_SLIDER_CONTAINER_READY_EVENT =
  "global-player-time-slider-container-ready";
export const GLOBAL_PLAYER_TIME_SLIDER_MOUNTED_EVENT =
  "global-player-time-slider-mounted";
export const GLOBAL_PLAYER_TIME_SLIDER_UNMOUNTED_EVENT =
  "global-player-time-slider-unmounted";

